declare namespace $ {

	export class $bog_ainews_app_page extends $mol_page {
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map